export const initTypeOfAccountForm = () => {
    // VARS

    const form = document.querySelector('[data-type-of-account-form]');
    if (!form) return;
    const inputs = form.querySelectorAll('[data-type-of-account-input]');
    const button = form.querySelector('[data-profile-button]');

    // EVENTS

    inputs.forEach((input) => input.addEventListener('change', handleOnChange, false));

    // HANDLERS

    function handleOnChange() {
        const atLeastOneChecked = Array.from(inputs).some((input) => input.checked);
        button.disabled = !atLeastOneChecked;
    }
};
